import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WalletSettingsState {
  twoFactorMethod: {
    email?: boolean;
    authenticator?: boolean;
  };
  selectedMethods: { email?: string; authenticator?: string };
  settingsStatus: "idle" | "saving" | "saved" | "error";
  password: string;
  otp: string;
  otpverified: boolean;
  qrCodeData: string | null,
  backupCodes: string[] | null;
  currentMethod: string;
  email: string
}

const initialState: WalletSettingsState = {
  twoFactorMethod: {
    email: false,
    authenticator: false,
  },
  selectedMethods: { email: "", authenticator: "" },
  settingsStatus: "idle",
  password: "",
  otp: "",
  otpverified: false,
  qrCodeData: null,
  backupCodes: null,
  currentMethod: "",
  email: ""
};

const walletSettingsSlice = createSlice({
  name: "walletSettings",
  initialState,
  reducers: {
    setTwoFactorMethod: (
      state,
      action: PayloadAction<{ email?: boolean; authenticator?: boolean }>
    ) => {

      state.twoFactorMethod = action.payload;
    },
    setSelectedMethods: (
      state,
      action: PayloadAction<{ email: string; authenticator: string }>
    ) => {
      state.selectedMethods = action.payload;
    },
    saveTwoFactorSettings: (
      state,
      action: PayloadAction<{ email?: boolean; authenticator?: boolean }>
    ) => {
      state.settingsStatus = "saving";

      // Simulate API save
      //   setTimeout(() => {
      //     state.settingsStatus = "saved";
      //   }, 1000);
    },
    setPassword(state, action: PayloadAction<string>) {
      state.password = action.payload;
    },
    setEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },


    setQrCodeData(state, action: PayloadAction<string | null>) {
      state.qrCodeData = action.payload;
    },

    setOtp(state, action: PayloadAction<string>) {
      state.otp = action.payload;
    },

    verifyOTP(state, action: PayloadAction<{ verified: boolean; backupCodes: string[] | null }>) {
      state.otpverified = action.payload.verified;
      state.backupCodes = action.payload.backupCodes;
    },

    resetTwoFactorSettings: (state) => {
      state.twoFactorMethod = { email: false, authenticator: false };
      state.settingsStatus = "idle";
    },

    setCurrentMethod(state, action: PayloadAction<string>) {
      state.currentMethod = action.payload;
    },
  },
});

export const {
  setTwoFactorMethod,
  setPassword,
  setSelectedMethods,
  setOtp,
  verifyOTP,
  saveTwoFactorSettings,
  resetTwoFactorSettings,
  setQrCodeData,
  setCurrentMethod,
  setEmail
} = walletSettingsSlice.actions;

export default walletSettingsSlice.reducer;
